// extracted by mini-css-extract-plugin
module.exports = {"container":"InlineLoading-module--container--272a36","dot":"InlineLoading-module--dot--516af1","up-and-down":"InlineLoading-module--up-and-down--708313"};